import { el } from './create-element';
import { __ } from '../helpers/i18n';
import { stopVideo } from './video';
export function modal(title = __('Uwaga!'), content, icon = 'icon--info-alt', className = '') {
    let modal = document.querySelector('.e-modal');
    let previousFocus = document.activeElement;
    const closeModal = () => {
        modal.classList.remove('open');
        setTimeout(() => {
            modal.style.display = 'none';
            if (previousFocus) {
                previousFocus.focus();
            }
        }, 300);
        stopVideo(modal);
    };
    if (!modal) {
        modal = el('div', { class: `e-modal ${className ?? ''}` }, [
            el('div', { class: "e-modal-overlay close" }),
            el('div', { class: "e-modal-box" }, [
                el('button', { class: "close close--top" }, el('span', { class: "icon icon--close-fill" })),
                el('div', { class: "e-modal-content" })
            ])
        ]);
        const contentBox = modal.querySelector('.e-modal-content');
        const closeButton = modal.querySelector('.close--top');
        if (content) {
            typeof content === 'string' ? contentBox.textContent = content : contentBox.appendChild(content);
        }
        document.body.appendChild(modal);
        setTimeout(() => closeButton.focus(), 300);
    }
    else {
        modal.className = `e-modal ${className ?? ''}`;
        const contentBox = modal.querySelector('.e-modal-content');
        const closeButton = modal.querySelector('.close--top');
        if (content) {
            contentBox.innerHTML = '';
            typeof content === 'string' ? contentBox.textContent = content : contentBox.appendChild(content);
        }
        setTimeout(() => closeButton.focus(), 300);
    }
    const closeButtons = modal.querySelectorAll('.close');
    if (closeButtons)
        closeButtons.forEach(button => {
            button.addEventListener('click', () => closeModal());
        });
    modal.style.display = 'block';
    setTimeout(() => {
        modal.classList.add('open');
    }, 0);
}
export function revealModal() {
    const reveals = document.querySelectorAll('[data-open]');
    if (!reveals)
        return;
    reveals.forEach(reveal => {
        const modalId = reveal.getAttribute('data-open');
        const modalClass = reveal.getAttribute('data-class');
        const modalIcon = reveal.getAttribute('data-icon');
        const modalTitle = reveal.getAttribute('data-title');
        const modalContent = document.getElementById(modalId);
        reveal.addEventListener('click', () => { modal(modalTitle, modalContent, modalIcon, modalClass); });
        const showModal = reveal.getAttribute('data-show-modal');
        if (showModal) {
            modal(modalTitle, modalContent, modalIcon, modalClass);
        }
    });
}
